import React, { useEffect, useState } from "react";
import { Box, IconButton } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import TransitionsModal from "../components/Modal";
import AdminLayout from "../layouts/AdminLayout";
import { BeatLoader } from "react-spinners";
import axios from "axios";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import { deleteApi, getApi, postApi } from "../config/configAxios";
import Swal from "sweetalert2";
import CustomLoader from "../components/CustomLoader";

const Users = () => {
  const [data, setData] = useState([]);
  const [errors, setErrors] = useState(null);
  const [storeData, setStoreData] = useState({});
  const [editData, setEditData] = useState({});
  const [loading, setLoading] = useState(true);
  const [openStore, setOpenStore] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchData = async () => {
    try {
      const res = await getApi(
        `${process.env.REACT_APP_API_BASE_URL}users`
      );
      setData(res.data);
    } catch (err) {
      toast.error(err?.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setStoreData((prevData) => ({ ...prevData, [name]: value }));
  };

  /// store
  const handleStore = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("name", storeData.name || "");
    formData.append("email", storeData.email || "");
    formData.append("password", storeData.password || "");
    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}register`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setOpenStore(false);
      setStoreData({});
      fetchData();
      setErrors(null);
      toast.success("Data created successfully!");
    } catch (err) {
      setErrors(err?.response?.data?.error);
      toast.error(err?.response?.data?.error || "update failed");
    } finally {
      setIsSubmitting(false);
    }
  };

  // delete
  const handleDelete = async (id) => {
    Swal.fire({
      title: "Confirm delete",
      text: "Are you sure you want to delete this user?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          try {
            await deleteApi(`user/${id}`)
              .then((res) => {
                toast.success("Data deleted successfully!");
              })
              .catch((err) => {
                toast.error(err?.response?.data?.error || "An error occurred while updating status");
              })
              .finally(() => {
                fetchData();
              });
          } catch (err) {
            toast.error(err?.response?.data?.error || "update failed");
          }
        } catch (error) {
          Swal.fire(
            "Error",
            "An error occurred while delete the user.",
            "error"
          );
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "The user was not deleted.", "info");
      }
    });
  };

  // edit
  const handleEdit = async (id) => {
    setOpenEdit(true);
    try {
      const res = await getApi(`user/${id}`);
      setEditData(res.data);
      setStoreData(res.data);
    } catch (err) {
      toast.error(err?.message);
    }
  };
  // handleUpdate
  const handleUpdate = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("name", storeData.name || "");
    formData.append("email", storeData.email || "");
    formData.append("password", storeData.password || "");
    try {
      await postApi(
        `${process.env.REACT_APP_API_BASE_URL}update-user/${editData.id}`,
        formData
      );
      setOpenEdit(false);
      setStoreData({});
      fetchData();
      setErrors(null);
      toast.success("Data updated successfully!");
    } catch (err) {
      setErrors(err?.response?.data?.error);
      toast.error(err?.response?.data?.error || "update failed");
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <AdminLayout title={"Users"}>
      {loading ? (
        <CustomLoader />
      ) : (
        <div>
          <div className="flex justify-between p-3">
            <h1 className="text-gray-700 font-medium">Users</h1>
            <div>
              <button className="btn-indigo" onClick={() => setOpenStore(true)}>
                Add new
              </button>
            </div>
          </div>
          <div className="table-wrap">
            <table className="table-main shadow-md">
              <thead className="table-h">
                <tr>
                  <th className="table-h">SN</th>
                  <th className="table-h">Name</th>
                  <th className="table-h">Email</th>
                  <th className="table-h">Action</th>
                </tr>
              </thead>
              <tbody className="table-b">
                {data.map((item, index) => (
                  <tr key={item.id}>
                    <td className="table-b">{index + 1}</td>
                    <td className="table-b">{item.name}</td>
                    <td className="table-b">{item.email}</td>
                    <td className="table-b">
                      <Box display="flex">
                        <IconButton
                          className="mr-3"
                          onClick={() => handleDelete(item.id)}
                        >
                          <Delete className="text-red-500" />
                        </IconButton>
                        <IconButton
                          className="mr-3"
                          onClick={() => handleEdit(item.id)}
                        >
                          <Edit className="text-blue-500" />
                        </IconButton>
                      </Box>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {/* modal  */}

      <TransitionsModal title={"Add"} open={openStore} setOpen={setOpenStore}>
        <form className="" onSubmit={handleStore}>
          <div className="grid md:grid-cols-2 grid-cols-1 gap-6">
            <div className="md:col-span-2">
              <label htmlFor="name" className="font-semibold text-sm">
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                onChange={handleInputChange}
                placeholder="name"
                className="form-control"
                required
              />
              <div className="text-red-500">{errors?.name}</div>
            </div>
            <div className="md:col-span-2">
              <label htmlFor="email" className="font-semibold text-sm">
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                onChange={handleInputChange}
                placeholder="email"
                className="form-control"
                required
              />
              <div className="text-red-500">{errors?.email}</div>
            </div>
            <div className="md:col-span-2">
              <label htmlFor="password" className="font-semibold text-sm">
                Password
              </label>
              <input
                type="password"
                id="password"
                name="password"
                onChange={handleInputChange}
                placeholder="password"
                className="form-control"
                // required
              />
              <div className="text-red-500">{errors?.password}</div>
            </div>
            <div className="md:col-span-2">
              <button
                disabled={isSubmitting}
                type="submit"
                className="btn-green w-full"
                data-ripple-light="true"
              >
                {isSubmitting ? <BeatLoader color="#fff" /> : "Submit"}
              </button>
            </div>
          </div>
        </form>
      </TransitionsModal>
      <TransitionsModal title={"Edit"} open={openEdit} setOpen={setOpenEdit}>
        <form className="" onSubmit={handleUpdate}>
          <div className="grid md:grid-cols-2 grid-cols-1 gap-6">
            <div className="md:col-span-2">
              <label htmlFor="name" className="font-semibold text-sm">
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={storeData?.name}
                onChange={handleInputChange}
                placeholder="name"
                className="form-control"
                required
              />
            </div>
            <div className="md:col-span-2">
              <label htmlFor="email" className="font-semibold text-sm">
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={storeData?.email}
                onChange={handleInputChange}
                placeholder="email"
                className="form-control"
                required
              />
            </div>
            <div className="md:col-span-2">
              <label htmlFor="password" className="font-semibold text-sm">
                Password
              </label>
              <input
                type="password"
                id="password"
                name="password"
                value={storeData?.password}
                onChange={handleInputChange}
                placeholder="password"
                className="form-control"
              />
            </div>
            <div className="md:col-span-2">
              <button
                disabled={isSubmitting}
                type="submit"
                className="btn-green w-full"
                data-ripple-light="true"
              >
                {isSubmitting ? <BeatLoader color="#fff" /> : "Update"}
              </button>
            </div>
          </div>
        </form>
      </TransitionsModal>
    </AdminLayout>
  );
};

export default Users;
